<template>
  <div class="search-card-course-outer d-flex align-items-stretch">
    <a class="search-card-course" v-b-modal.modal-course-details @click="select" tabindex="0">
      <div class="search-card-course__label-credits">Credits: {{ result.requiredCredits }}</div>
      <div class="search-card-course__code">
        <i v-if="result.isWhitelisted" class="far fa-badge-check" :id="`whitelist-badge-tooltip-${ result.courseCode }`"></i>
        {{ result.courseCode }}
      </div>
      <div class="search-card-course__title">{{ result.name }}</div>
      <div class="search-card-course__major-flag" v-if="searchMajorResult">
        <span>Major</span> matches your search
      </div>
      <div class="search-card-course__content" v-if="result.description.length <= 160">{{ result.description | cleanHTML }}</div>
      <div class="search-card-course__content" v-else>{{ result.description.substring(0, 160) | cleanHTML}}...</div>

      <div v-if="isReviewer" class="float-right mt-2">
        <div v-if="result.status != 'Active'" class="badge badge-primary">{{ statusLabel(result.status) }}</div>
        <div class="badge badge-secondary">Version {{ result.courseLoopVersionNumber }}</div>
      </div>

    </a>
    <b-tooltip v-if="result.isWhitelisted" :target="`whitelist-badge-tooltip-${ result.courseCode }`" triggers="hover" placement="right">
      This course can be planned using the {{ __('label:app title') }}
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HtmlHelper from 'common/helpers/html'

export default {
  props: ['result'],
  filters: {
    cleanHTML: (text) => {
      return text != null ? HtmlHelper.removeTags(text) : ''
    }
  },
  computed: {
    ...mapGetters({
      getSearchParams: 'courses/getSearchCourseParams',
      isReviewer: 'global/isReviewer',
    }),
    searchMajorResult() {
      const searchArray = this.getSearchParams.searchString.split(' ')
      var titleContainsSearch = false
      if (searchArray) {
        searchArray.forEach((item) => {
          if (this.result.name.toLowerCase().includes(item.toLowerCase()) ||
              this.result.courseCode.toLowerCase().includes(item.toLowerCase())) {
            titleContainsSearch = true
          }
        })
      }
      return !titleContainsSearch
    }
  },
  methods: {
    select() {
      this.$emit('courseClick', this.result.id, this.isReviewer ? this.result.courseLoopVersionNumber : null, this.isReviewer && this.result.status == 'Draft')
    },
    statusLabel(id) {
      return this.__(`label:status ${id.toLowerCase()}`)
    }
  }
}
</script>
